import React, { Fragment } from "react";
import _debounce from "lodash/debounce";
import DateRangeWidget from "../DateRangeWidget";

function PermitValidityWidget(props: any) {
  return (
    <DateRangeWidget {...props} />
  );
};

PermitValidityWidget.defaultProps = {};

PermitValidityWidget.propTypes = {};

export default PermitValidityWidget